var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ShareButton',{attrs:{"baseClass":("common_btn " + _vm.size + " " + (_vm.type || '') + " " + (_vm.theme || ''))},nativeOn:{"click":function($event){return _vm.btnHandle($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }